import { ReactComponent as BellIcon } from './bell.svg';

export default BellIcon;
